<template>
    <b-modal ref="edit-additional-modal" size="lg" hide-footer id="edit-additional-modal" :no-close-on-backdrop="true" title="Редактирование дополнительных данных">
        <step-two :edit-data="editData" :registration-data="registrationData" @userDataUpdated="userDataUpdatedListener"></step-two>
    </b-modal>
</template>

<script>
    import StepTwo from "../../../views/auth/registration/step-two/StepTwo";
    import {authService} from "../../../_api";

    export default {
        name: 'editAdditionalModal',
        props: [''],
        data() {
            return {
                editData: null,
                registrationData: null
            }
        },
        components: {
            'step-two': StepTwo
        },
        methods: {
            showModal(data) {
                // console.log(data);
                this.editData = data;
                this.$refs['edit-additional-modal'].show();
            },
            userDataUpdatedListener() {
                this.$refs['edit-additional-modal'].hide();
                this.$emit('userDataUpdated');
            }
        },
        beforeCreate() {},
        created() {
            authService.getRegData().then((res) => {
                this.registrationData = res;
            })
        }
    }
</script>

<style lang="less">
    #edit-additional-modal {
        .modal-dialog {
            &.modal-xl {
                max-width: 960px;
            }
            .modal-content {
                .modal-header {
                    .modal-title {
                        font-weight: normal;
                        font-size: 16px;
                        line-height: 19px;
                        color: rgba(51, 51, 51, 0.9);
                    }
                }
                .modal-body {
                    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.15);
                    padding: 0;
                    .loading-wrapper {
                        width: 100%;
                        height: 80vh;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .modal-footer {

                }
            }
        }
    }
</style>
